import { formatMeters } from "../../ExportExcelButtonV3/utils";
import { sumElementMultipliers } from "../sumElementMultipliers";
import type {
  BuildElementsLegend,
  BuildExportLegend,
  BuildRoutesLegend,
  LegendItem,
} from "./types";

const buildRoutesLegend: BuildRoutesLegend = ({
  selectedLabels,
  byRouteGroupLabel,
  t,
}) => {
  const groups = selectedLabels.flatMap((label) => {
    const group = byRouteGroupLabel[label];
    return group ? [group] : [];
  });
  const items: LegendItem[] = groups.map((group) => ({
    label: group.label,
    value: formatMeters(group.meters),
    rgb: group.rgb,
  }));
  const totalMeters = groups.reduce((sum, group) => sum + group.meters, 0);
  return {
    items,
    summary: {
      left: t("smartSurveyor.exportExcel.legendRouteGroupsCount", {
        count: items.length,
      }),
      right: t("smartSurveyor.exportExcel.legendTotalLength", {
        value: formatMeters(totalMeters),
      }),
    },
  };
};

const buildElementsLegend: BuildElementsLegend = ({
  selectedLabels,
  byGroupId,
  t,
}) => {
  const items: LegendItem[] = selectedLabels.flatMap<LegendItem>((label) => {
    const elements = byGroupId[label] ?? [];
    if (elements.length === 0) return [];
    return [
      {
        label,
        value: String(sumElementMultipliers({ elements })),
        rgb: elements[0].rgb,
      },
    ];
  });
  const elementsTotal = selectedLabels.reduce(
    (sum, label) =>
      sum + sumElementMultipliers({ elements: byGroupId[label] ?? [] }),
    0,
  );
  return {
    items,
    summary: {
      left: t("smartSurveyor.exportExcel.legendGroupsCount", {
        count: items.length,
      }),
      right: t("smartSurveyor.exportExcel.legendElementsCount", {
        count: elementsTotal,
      }),
    },
  };
};

export const buildExportLegend: BuildExportLegend = (args) =>
  args.isCablesView ? buildRoutesLegend(args) : buildElementsLegend(args);
